// RatingSummaryTable.jsx
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Row = styled.div`
  display: flex;
  align-items: flex-start;
`

const RatingLetter = styled.span`
  width: 32px;
  flex-shrink: 0;
  text-align: left;
  font-weight: bold;
  margin-right: 8px; 
`

const Explanation = styled.span`
  flex: 1;   
  line-height: 1.4;
`

export function RatingSummaryTable(ratingType) {
  const { type } = ratingType;

  // Verdier hentet fra Bislab sin dokumentasjon
  const næringRows = [
    { letter: 'AAA', explanation: 'Meget høy kredittverdighet' },
    { letter: 'AA', explanation: 'Høy kredittverdighet' },
    { letter: 'A', explanation: 'Kredittverdig' },
    { letter: 'B', explanation: 'Lav kredittverdighet' },
    { letter: 'C', explanation: 'Meget lav kredittverdighet' },
    { letter: 'D', explanation: 'Ikke kredittverdig' },
    { letter: 'IR', explanation: 'Ingen score' },
    { letter: 'AN', explanation: 'Nyoppstartet' },
  ]
    
  const privatRows = [
    { letter: 'A', explanation: 'Meget høy kredittverdighet' },
    { letter: 'B', explanation: 'Høy kredittverdighet' },
    { letter: 'C', explanation: 'Kredittverdig' },
    { letter: 'D', explanation: 'Lav kredittverdighet' },
    { letter: 'E', explanation: 'Meget lav kredittverdighet' },
    { letter: 'IR', explanation: 'Ingen score' },
    { letter: 'KS', explanation: 'Kredittsperre finnes. Må oppheves før data kan utleveres.' },
  ]

  const rows = type === 'Næring' ? næringRows : privatRows;

  return (
    <Container>
      {rows.map(({ letter, explanation }) => (
        <Row key={letter}>
          <RatingLetter>{letter}</RatingLetter>
          <Explanation>{explanation}</Explanation>
        </Row>
      ))}
    </Container>
  )
}

